import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import api from "./assets/js/apis";
import ElementUI from "element-ui";
import i18n from "./i18n";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);
Vue.use(i18n);

Vue.config.productionTip = false;
Vue.prototype.$api = api;

// 确保 $i18n 在根实例上可用
new Vue({
  router,
  store,
  data: {
    $i18n: {
      language: localStorage.getItem('lang') || 'zh'
    }
  },
  render: (h) => h(App),
}).$mount("#app");
